import * as go from 'gojs';

go.Diagram.licenseKey = '298647e0b36648c702d90676423d6bf919a175639c8418a30e0413f6e9083c06329fea2859d3829787ac4eff1f7d90d0dcc03e20c349023fe531dbdb11e18ea9bb3373e5140a4f88a45626969eff2bf1ae6a61f497e571a288288de0fba8c5cc08e0a3';

import React, { useEffect, useRef } from 'react';
import { useApiListener } from '@process-advisor/process-miner/shared/hooks/useApiListener';
import { getVisualizerBackgroundColorDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import {
    StyledWrapper,
    StyledContent,
    StyledModal,
    StyledHeader,
    StyledIcon,
    StyledFooter,
    StyledTitle,
} from '@process-advisor/process-miner/components/modal/modal.styles'
import { Event } from '@process-advisor/process-miner/api/events';
import styled from 'styled-components';
import { getZIndex } from '@process-advisor/process-miner/shared/theme';
import { Typography } from '@mui/material';
import { Checkbox } from '@process-advisor/process-miner/components/shared/checkbox';
import { SingleBlock } from '@process-advisor/process-miner/components/layout/singleBlock';

const Diagram = styled.div<{ color: string }>`
    background-color: ${({ color }) => color};
    width: 800px;
    height: 60vh;
    border: hidden;
    canvas {
        outline: none;
    };
    z-index: ${getZIndex('diagram')};
`;

type Props = {
    data: {
        workflow: string,
        nodeDataArray: any,
        linkDataArray: any,
    },
}

export type ShowUnusedProps = {
    visible?: boolean;
}

export type ShowLabelsProps = {
    visible?: boolean;
}

let nodeDataArray = []
let linkDataArray = []

export const ViewWorkflowModal: React.FC = () => {
    const ref = useRef();
    const [data, setData] = React.useState<{ workflow: string, nodeDataArray: any, linkDataArray: any}>({ workflow: '', nodeDataArray: [], linkDataArray: []});
    const [open, setOpen] = React.useState(false);
    const [showCloseIcon, setShowCloseIcon] = React.useState(true);
    const [VisualizerBackground, setVisualizerBackground] = React.useState<string>('');
    const [showUnused, setShowUnused] = React.useState<ShowUnusedProps>({visible: false});
    const [showLabels, setShowLabels] = React.useState<ShowLabelsProps>({visible: true});

    const onChangeShowUnused = (key: keyof ShowUnusedProps) => (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const newShowUnused = { ...showUnused, [key]: e.target.checked };
        setShowUnused(newShowUnused);
    };

    const onChangeShowLabels = (key: keyof ShowLabelsProps) => 
    (e: React.ChangeEvent<HTMLInputElement>) => {
        const newShowLabels = { ...showLabels, [key]: e.target.checked };
        setShowLabels(newShowLabels);
    };

    useEffect(() => {
        for (let k = 0; k <  linkDataArray.length; k++) {
            linkDataArray[k].visible = true
            if (showUnused.visible === false && linkDataArray[k].work_items === 0) linkDataArray[k].visible = false
        }
        const myDiagram = go.Diagram.fromDiv('myDiagramDiv');
        if (myDiagram !== null) {

            let newLinkDataArray = []
            for (let k = 0; k <  linkDataArray.length; k++) {
                linkDataArray[k].visible = true
                if (showUnused.visible === false && linkDataArray[k].work_items === 0) linkDataArray[k].visible = false
                if (linkDataArray[k].visible === true) newLinkDataArray.push(linkDataArray[k])
            }

            myDiagram.startTransaction('layout');
            let lay = myDiagram.layout;
            myDiagram.model.nodeDataArray = nodeDataArray
            myDiagram.model.linkDataArray = newLinkDataArray 
            myDiagram.layout.layerSpacing = 80;
            myDiagram.layout.rowSpacing = 30;
            myDiagram.requestUpdate();
            myDiagram.zoomToFit();
            myDiagram.commitTransaction('layout');
        }
    }, [showUnused])


    useEffect(() => {

        for (let k = 0; k < linkDataArray.length; k++) {
            linkDataArray[k].label_visible = true
            if (showLabels.visible === false ) linkDataArray[k].show_labels = false
        }
        const myDiagram = go.Diagram.fromDiv('myDiagramDiv');
        if (myDiagram !== null) {

            myDiagram.model.linkDataArray = linkDataArray 
            myDiagram.startTransaction('layout');
            let lay = myDiagram.layout;
            myDiagram.requestUpdate();
            myDiagram.zoomToFit();
            myDiagram.commitTransaction('layout');
        }
    }, [showLabels])


    function onClose() {
        setOpen(false)
    }

    useApiListener(
        Event.openWorkflowModal,
        ({ data }: Props) => {
            setOpen(true);
            setData(data);
            console.log(data)
            linkDataArray = data.linkDataArray
            nodeDataArray = data.nodeDataArray
            setVisualizerBackground(getVisualizerBackgroundColorDiagram());
            const timer = setTimeout(() => {
                buildWorkflowDiagram()
            }, 100);
            return () => clearTimeout(timer);
        }
    );

    function buildWorkflowDiagram() {

        let $ = go.GraphObject.make;
        let myDiagram = new go.Diagram('myDiagramDiv', {
          'undoManager.isEnabled': true, // enable undo & redo
        });
    
        myDiagram.toolManager.mouseWheelBehavior = go.ToolManager.WheelZoom;
        myDiagram.toolManager.hoverDelay = 10;
        myDiagram.toolManager.toolTipDuration = 10000;
    
        myDiagram.nodeTemplate = $(
            go.Node,
            'Auto',
            { isShadowed: true},
            new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify),
            $(
                go.Shape, 
                { strokeWidth: 0, 
                  portId: '', 
                  figure: 'RoundedRectangle',
                  parameter1: 10,
                  fromLinkable: true,
                  toLinkable: true,
                  fromSpot: go.Spot.AllSides,
                  toSpot: go.Spot.AllSides,
                  cursor: 'pointer', 
                  'fill': '#3669E1'},
            ),
            $(
              go.Panel,
                $(
                    go.TextBlock, 
                    { margin: 1, 
                      textAlign: 'start',  
                      stroke:  '#fff',
                      font: '12pt system-ui'},
                    new go.Binding('text', 'text')
                )
            ),
        );
    
        myDiagram.linkTemplate = $(
          go.Link, // the whole link panel
          { reshapable: true, 
            adjusting: go.Link.Stretch,
            routing: go.Link.AvoidsNodes,
            curve: go.Link.JumpOver,
            corner: 5,
            toShortLength: 4,
            relinkableFrom: true,
            relinkableTo: true,
            resegmentable: true,
          },
            $('Shape', { strokeWidth: 2 }, 
                new go.Binding('stroke', 'fill'),
                new go.Binding('visible', 'visible')
            ),
            $('Shape', { stroke: null, toArrow: 'Triangle' },  new go.Binding('fill', 'fill')),
            {
              toolTip:  
                go.GraphObject.build("ToolTip")
                .add(
                  new go.TextBlock({ margin: 4 })
                    .bind("text", "tooltip")
                )  // end of Adornment
            },
            $(
                go.Panel,
                'Auto',
                $(
                    go.Shape, // the label background, which becomes transparent around the edges
                    {
                        fill: $(go.Brush, 'Radial', { 0: 'rgb(240, 240, 240)', 0.3: 'rgb(240, 240, 240)', 1: 'rgba(240, 240, 240, 0)' }),
                        stroke: null,
                    }
                ),
                $(
                    go.TextBlock, // the label text
                    {
                        textAlign: 'center',
                        font: '8pt system-ui',
                        margin: 8,
                    },
                    new go.Binding('visible', 'label_visible'),
                    new go.Binding('text', 'work_items')
                )
            )
        );
        myDiagram.model.nodeDataArray = nodeDataArray
        myDiagram.model.linkDataArray = linkDataArray
        myDiagram.zoomToFit();
        setShowUnused({visible: true});

    }

    return (
        <StyledWrapper open={open} onClose={onClose}>
            <StyledModal >
                <StyledHeader>
                    <StyledTitle>Workflow View</StyledTitle>
                    {showCloseIcon ? <StyledIcon onClick={onClose} /> : <div />}
                </StyledHeader>
                <Typography
                    variant="caption"
                    align="center"
                    sx={{ fontSize: '18px', fontWeight: '400', fontFamily: 'system-ui'
}}
                    component="div">
                    {data.workflow}
                </Typography>                
                <StyledContent>
                    <Diagram ref={ref} id="myDiagramDiv" color={VisualizerBackground} ></Diagram> 
                </StyledContent>
                <StyledFooter>
                    <SingleBlock width="30%">
                        <Typography
                            variant="caption"
                            align="right"
                            sx={{ fontSize: '12px', fontWeight: '400', fontFamily: 'system-ui'}}
                            component="div">
                            Show Unused Transitions
                        </Typography>                
                    </SingleBlock>
                    <SingleBlock width="10%">
                        <Checkbox
                            label=''
                            checked={!!showUnused.visible}
                            handleOnChange={onChangeShowUnused('visible')} />
                    </SingleBlock>
                </StyledFooter>
            </StyledModal>
        </StyledWrapper>
    );
};

/*
                    <SingleBlock width="30%">
                        <Typography
                            variant="caption"
                            align="right"
                            sx={{ fontSize: '12px', fontWeight: '400', fontFamily: 'system-ui'}}
                            component="div">
                            Show Transition Labels
                        </Typography>                
                    </SingleBlock>
                    <SingleBlock width="30%">
                        <Checkbox
                            label=''
                            checked={!!showLabels.visible}
                            handleOnChange={onChangeShowLabels('visible')} />
                    </SingleBlock>
*/